import React, { Component } from "react";
import ChiffresClesStatistiquesUsage from "../Base/ChiffresClesStatistiquesUsage/ChiffresClesStatistiquesUsage";
import ChartsStatistiquesUsages from "../Base/ChartsStatistiquesUsages/ChartsStatistiquesUsages";

//  pour le bien être ressentis
import { Row, Col } from "reactstrap";
import Tables from "../Base/Tables/Tables";
import ChiffresClesBienEtreRessenti from "../Base/ChiffresClesBienEtreRessenti/ChiffresClesBienEtreRessenti";
import ChartsBienEtreRessenti from "../Base/ChartsBienEtreRessenti/ChartsBienEtreRessenti";

// pour les message d'erreur et les filtres
import { ToastContainer, toast } from "react-toastify";
import TagsFilters from "../TagsFilters/TagsFilters";


class AdminDashboard extends Component {
    constructor() {
      super();
      this.state = {
        error: false,
        newFetch: false
      };
    }

    componentDidMount() {
        //  récuperation de la date de début pour une company

    }

    //  préparation de la requete avec les filtres
    getTagsRequest() {
        let res = "";
        if (window.selectedTags) {
          window.selectedTags.forEach(tag => {
            res.length
              ? (res = res + "&tags[]=" + tag)
              : (res = res + "?tags[]=" + tag);
          });
        }

        //  si on a bien les dates de selectionnées, on les ajoute à la requete
        if (window.startDateMysql) {
            (res != "")
              ? (res = res + "&startDate=" + window.startDateMysql)
              : (res = res + "?startDate=" + window.startDateMysql);
        }

        //  si on a bien les dates de selectionnées, on les ajoute à la requete
        if(window.endDateMysql) {
            (res != "")
              ? (res = res + "&endDate=" + window.endDateMysql)
              : (res = res + "?endDate=" + window.endDateMysql);
        }
        res = "/" + this.props.params.id  + res;
        return res;
    }


    updateData() {
      try {
        this.setState({newFetch: !this.state.newFetch});
      } catch (e) {
        console.log(e);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.error) {
        this.setState({ error: false });
      }
    }

    notifyError() {
      toast.error(
        "Les tags sélectionnés sont trop précis, merci de sélectionner moins de tags."
      );
      this.setState({ error: true });
    }


  render() {
    return (
      <div className="animated fadeIn">
        <ToastContainer/>
        <br/>
        <TagsFilters
            error={this.state.error}
            updateData={this.updateData.bind(this)}
            id={this.props.params.id}
        />
        <h3>Statistiques d'usage</h3>
        <ChiffresClesStatistiquesUsage
            request={this.getTagsRequest()}
            isAdmin={false}
            notifyError={this.notifyError.bind(this)}
            error={this.state.error}
            newFetch={this.state.newFetch}
        />
        <ChartsStatistiquesUsages
            request={this.getTagsRequest()}
            isAdmin={true}
            notifyError={this.notifyError.bind(this)}
            error={this.state.error}
            newFetch={this.state.newFetch}
        />

        <hr />
        <h3>Bien-être ressenti</h3>
        <ChiffresClesBienEtreRessenti
          request={this.getTagsRequest()}
          isAdmin={true}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByUniverses"
              id={this.props.params.id}
              perPage={3}
            />
          </Col>
        </Row>
        <ChartsBienEtreRessenti
          request={this.getTagsRequest()}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByThematics"
              id={this.props.params.id}
              perPage={12}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByQuestions"
              id={this.props.params.id}
              perPage={20}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/views/AdminDashboard/AdminDashboard.js